import { Info } from "lucide-react";

/**
 * A short pointer on the audience pages: sending different things to
 * different people is done with tiers on the campaign, not with separate
 * audiences. Wording agreed with the product owner (direct-mail campaigns,
 * 8 Oct 2026); keep it verbatim.
 */
export function TiersHelpNote() {
  return (
    <p className="flex items-start gap-2 text-sm text-muted-foreground">
      <Info className="size-4 mt-0.5 shrink-0" aria-hidden="true" />
      <span>
        Do different contacts in your audience need to receive different
        content? Set <strong className="text-foreground">tiers</strong> on your
        campaign. If everyone on your campaign receives all the same, then tiers
        are not needed.
      </span>
    </p>
  );
}
